import React from 'react'

const Manual_limitar_categorias_horario = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Cómo limitar categorías por horario
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a restringir categorías de productos según franjas horarias dentro del e-commerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_limitar_categorias_por_horario__FbMgnQLLR-ygM9W2xrfcFg?as=scrollable"
          className="scribe-iframe-general-117"
          width="100%"
          height="6600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_limitar_categorias_horario
